/* ════════════════════════════════════════════════════════════════
   FBT — Sıkça Birlikte Alınanlar (Frequently Bought Together)
   ----------------------------------------------------------------
   • Vanilla, bağımlılıksız. defer ile yüklenir.
   • Anchor (bu ürün) varyantı CANLI okunur (.product-variant-id) —
     varyant değişince anchor fiyatı + toplam güncellenir.
   • Çoklu ekleme: tek /cart/add.js (items[]) — atomik.
   • Sepet bildirimi: product-form.js deseni birebir
     (cart-notification.getSectionsToRender + publish cartUpdate + renderContents).
   ════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── Shopify formatMoney (kanonik) — | money çıktısıyla birebir aynı ── */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, precision, thousands, decimal) {
      precision = (precision === 0 || precision) ? precision : 2;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cent = parts[1] ? decimal + parts[1] : '';
      return dollars + cent;
    }
    var match = (format || '').match(placeholder);
    var token = match ? match[1] : 'amount';
    var value = '';
    switch (token) {
      case 'amount':                                   value = fmt(cents, 2); break;
      case 'amount_no_decimals':                       value = fmt(cents, 0); break;
      case 'amount_with_comma_separator':              value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator':  value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator':         value = fmt(cents, 2, "'", '.'); break;
      default:                                         value = fmt(cents, 2);
    }
    return (format || '{{amount}}').replace(placeholder, value);
  }

  /* ── Sepet sayaç balonu güncelleyici (null-safe) ──
     /cart/add.js 'sections' yanıtından #cart-icon-bubble'ı çıkarıp, host
     DOM'da VARSA günceller. Host yoksa sessizce geçer (Dawn'da bu nokta patlıyordu). */
  function sectionInnerHTML(html) {
    if (!html) return null;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var sec = tmp.querySelector('.shopify-section');
    return sec ? sec.innerHTML : html;
  }
  function updateCartBubble(response) {
    var host = document.getElementById('cart-icon-bubble');
    if (!host || !response || !response.sections) return;
    var inner = sectionInnerHTML(response.sections['cart-icon-bubble']);
    if (inner != null) host.innerHTML = inner;
  }

  function init() {
    var root = document.querySelector('[data-fbt]');
    if (!root) return;

    var moneyFormat = root.dataset.moneyFormat || '{{amount}}';
    var totalEl     = root.querySelector('[data-fbt-total]');
    var countEl     = root.querySelector('[data-fbt-count]');
    var anchorPxEl  = root.querySelector('[data-fbt-anchor-price]');
    var btn         = root.querySelector('[data-fbt-add-all]');
    var errEl       = root.querySelector('[data-fbt-error]');
    var addons      = Array.prototype.slice.call(root.querySelectorAll('[data-fbt-add]'));

    if (!btn) return;

    /* Anchor varyant ID'si CANLI — Dawn hidden input (variant değişince güncellenir) */
    function anchorVariantId() {
      var inp = document.querySelector('.product-variant-id');
      return inp ? parseInt(inp.value, 10) : null;
    }
    function anchorPrice() {
      return parseInt(root.dataset.anchorPrice || '0', 10) || 0;
    }

    /* ── Toplam + sayım yeniden hesapla ── */
    function recompute() {
      var total = anchorPrice();   // anchor daima dahil
      var count = 1;
      addons.forEach(function (c) {
        if (c.checked) {
          total += parseInt(c.dataset.price || '0', 10) || 0;
          count += 1;
        }
      });
      if (totalEl) totalEl.textContent = formatMoney(total, moneyFormat);
      if (countEl) countEl.textContent = count;
    }

    addons.forEach(function (c) { c.addEventListener('change', recompute); });

    /* ── Varyant değişince anchor fiyatını + toplamı güncelle ── */
    var anchorWasEl = root.querySelector('[data-fbt-anchor-was]');
    var mount = document.getElementById(root.dataset.sectionMount || '');
    if (mount) {
      mount.addEventListener('variant:change', function (e) {
        if (!e.detail || !e.detail.variant) return;
        var price = e.detail.variant.price; // cents
        if (price == null) return;
        root.dataset.anchorPrice = String(price);
        if (anchorPxEl) anchorPxEl.textContent = formatMoney(price, moneyFormat);
        /* Eski fiyat (compare_at) — varyant indirimliyse göster, değilse gizle */
        var cmp = e.detail.variant.compare_at_price;
        if (anchorWasEl) {
          if (cmp != null && cmp > price) {
            anchorWasEl.textContent = formatMoney(cmp, moneyFormat);
            anchorWasEl.hidden = false;
            if (anchorPxEl) anchorPxEl.classList.add('fbt-row__price-now--sale');
          } else {
            anchorWasEl.hidden = true;
            anchorWasEl.textContent = '';
            if (anchorPxEl) anchorPxEl.classList.remove('fbt-row__price-now--sale');
          }
        }
        recompute();
      });
    }

    /* ── "Hepsini Sepete Ekle" — çoklu add ── */
    btn.addEventListener('click', function () {
      if (errEl) { errEl.hidden = true; errEl.textContent = ''; }

      var items = [];
      var aId = anchorVariantId();
      if (aId) items.push({ id: aId, quantity: 1 });
      addons.forEach(function (c) {
        if (c.checked) {
          var vId = parseInt(c.dataset.variantId, 10);
          if (vId) items.push({ id: vId, quantity: 1 });
        }
      });
      if (!items.length) return;

      btn.disabled = true;
      root.classList.add('is-loading');

      /* Sepet UI'ı — product-form.js ile birebir aynı kaynak */
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var body = { items: items, sections_url: window.location.pathname };
      /* Sepet balonu (#cart-icon-bubble) HER ZAMAN istenir — cart bileşeni olsa da
         olmasa da header badge'i güncelleyebilmek için. */
      var sectionIds = ['cart-icon-bubble'];
      if (cart && typeof cart.getSectionsToRender === 'function') {
        cart.getSectionsToRender().forEach(function (s) {
          if (sectionIds.indexOf(s.id) === -1) sectionIds.push(s.id);
        });
      }
      body.sections = sectionIds;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok || data.status) {
              var msg = (data && data.description) || 'Ürünler eklenemedi.';
              throw new Error(msg);
            }
            return data;
          });
        })
        .then(function (response) {
          /* Dawn pub-sub — temanın diğer aboneleri (cross-sell, drawer, bottom-nav) */
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'fbt', cartData: response });
          }
          /* Header sepet badge'ini güvenli güncelle (null-guard) */
          updateCartBubble(response);
          /* Cart-notification toast — varsa göster; eksik host patlatmasın diye korumalı */
          if (cart && typeof cart.renderContents === 'function') {
            try { cart.renderContents(response); } catch (e) { /* host eksik olabilir */ }
          }
        })
        .catch(function (err) {
          if (errEl) {
            errEl.textContent = (err && err.message) ||
              'Bazı ürünler stokta kalmamış olabilir. Lütfen sayfayı yenileyin.';
            errEl.hidden = false;
          }
        })
        .finally(function () {
          btn.disabled = false;
          root.classList.remove('is-loading');
        });
    });

    recompute(); // ilk yük: tüm tamamlayıcılar seçili
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
